<template>
    <div class="view__tabs">
        <ul class="view__tabs--menu">
            <li :class="getCssClass(['member-detail', 'member'])">
                <router-link :to="{ name: 'member-detail', params}">
                    {{ L.localize('Label_Definition') }}
                </router-link>
            </li>
            <li :class="getCssClass(['member-history', 'member-invoice'])">
                <router-link :to="{ name: 'member-history', params}">
                    {{ L.localize('Label_Subscriptions') }}
                </router-link>
            </li>
            <li :class="getCssClass('member-audit-logs')">
                <router-link :to="{ name: 'member-audit-logs', params}">
                    {{ L.localize('Label_AuditLogs') }}
                </router-link>
            </li>
        </ul>

        <dropdown
          v-on:delete="deleteMember"
          :label="actions.label"
          :links="actions.links"
          :isNotSync="true"
          acc="actions">
        </dropdown>
    </div>
</template>

<script>
import Dropdown from 'components/partials/Dropdown'
import L from 'services/Localization'
import { mapGetters } from 'vuex'
import notifications from 'mixins/notifications'
import _ from 'lodash'

export default {
  name: 'Submenu',
  components: { Dropdown },
  mixins: [notifications],
  data() {
    return {
      L: L
    }
  },
  computed: {
    ...mapGetters({
      member: 'activeMember'
    }),
    params() {
      let parameters = {}
      if (this.member) {
        parameters.params = { id: this.member.id }
      }
      return parameters
    },
    actions() {
      let params = this.params
      let menu = {
        label: L.localize('Label_Actions'),
        links: []
      }

      menu.links.push({
        label: L.localize('Label_Edit'),
        url: { name: 'member', params },
        acc: 'edit'
      })

      menu.links.push({
        label: L.localize('Members_ChangeGroup'),
        url: { name: 'member-change-group', params },
        acc: 'change-group'
      })

      menu.links.push({
        label: L.localize('Label_Delete'),
        bypassRouter: true,
        asFunction: true,
        url: 'delete',
        acc: 'delete'
      })
      return menu
    }
  },
  methods: {
    getCssClass(name) {
      let currentRouteName = this.$route.name
      let exactMatch = name === currentRouteName
      if (_.isArray(name)) {
        exactMatch = _.includes(name, currentRouteName)
      }
      let baseClass = exactMatch ? 'active' : ''
      return `view__tabs--tab ${baseClass}`
    },
    deleteMember() {
      this.$store.dispatch('deleteMember', this.$route.params.id).then(() => {
        this.showNotification({
          title: L.localize('Label_SuccessDeletion'),
          message: L.localize('Label_Success')
        })
        this.$router.push({name: 'members'})
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// Submenu.vue?7f894f26